import React, { FC, ReactNode } from 'react';
import { HStack, Text } from '@chakra-ui/react';

interface Props {
  label: string | ReactNode;
  value: string;
}

export const InfoRow: FC<Props> = ({ label, value }) => {
  return (
    <HStack justifyContent="space-between" mb={2}>
      {typeof label === 'string' ? (
        <Text fontSize="14px" fontWeight={400} lineHeight="26px" color="gray.4">
          {label}
        </Text>
      ) : (
        label
      )}

      <Text fontSize="14px" fontWeight={500} lineHeight="26px" color="white">
        {value}
      </Text>
    </HStack>
  );
};
